<template>
    <div class="tab-pane" :id="id" :class="{ active: isActive }">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        id: string;
        isActive?: boolean;
    }>();
</script>
